export const HRMS_API_ERROR_EVENT = 'hrmsApiError';

export function getApiErrorMessage(payload, fallback = 'Something went wrong') {
  const data = payload?.data ?? payload;
  const message = data?.message ?? payload?.message;

  if (Array.isArray(message)) {
    const combined = message.map((item) => String(item || '').trim()).filter(Boolean).join(', ');
    if (combined) return combined;
  }

  if (typeof message === 'string' && message.trim()) return message.trim();
  if (typeof data?.error === 'string' && data.error.trim()) return data.error.trim();
  if (typeof data === 'string' && data.trim()) return data.trim();
  return fallback;
}

export function notifyApiError(payload, fallback) {
  const message = getApiErrorMessage(payload, fallback);
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(HRMS_API_ERROR_EVENT, {
      detail: {
        message,
        status: Number(payload?.status || payload?.statusCode || payload?.data?.statusCode || 0) || null
      }
    }));
  }
  return message;
}
